// extracted by mini-css-extract-plugin
export default {"page":"style_page__Dafze","wrapper":"style_wrapper__k1AxH","controls":"style_controls__b37n6","control":"style_control__q9rnh","actions":"style_actions__waV5Y"};